import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { CompleteUser } from '../../../../types';
import { parseUser } from '../../../../utils/parseUser';
import { LoginRequest } from '../../../requests/Auth/LoginRequest';

type Props = {
	onSuccess: () => void;
	onError?: (error: AxiosError) => void;
	onSettled: () => void;
};

export const useLoginMutation = ({ onSuccess, onError, onSettled }: Props) => {
	const queryClient = useQueryClient();

	return useMutation(
		(params: { email: string; password: string }) => LoginRequest(params),
		{
			onSuccess: (response: { data: CompleteUser }) => {
				queryClient.setQueryData('user', parseUser(response.data));
				if (onSuccess) onSuccess();
			},
			onError: (error: AxiosError) => {
				if (onError) onError(error);
			},
			onSettled: () => {
				if (onSettled) onSettled();
			},
		},
	);
};
